import "./index.scss";
import { ErrorBoundary, ScrollToTop } from "./components";
import App from "./App";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { redirectFromOldUrls } from "./services/redirect-service";
import { store } from "./redux/store";

redirectFromOldUrls();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
